import { isEmpty } from 'lodash'
import { bulletSection } from '../helper'

export default [
  {
    generate({ answers }) {
      const textPieces = []

      if (!isEmpty(answers['40.a'])) {
        textPieces.push(`VEF1: ${answers['40.a']}% do previsto`)
      }

      if (!isEmpty(answers['40.b'])) {
        textPieces.push(`VEF1/CVF: ${answers['40.b']}`)
      }

      if (answers['40.c'] === 'sim') {
        textPieces.push(`Tem prova ao broncodilatador positiva`)
      }

      if (!isEmpty(answers['40.d'])) {
        textPieces.push(`Laudo: ${answers['40.d']}`)
      }

      const sections = []

      if (textPieces.length) {
        sections.push(bulletSection('Espirometria:', textPieces))
      }

      return sections
    },
    version: {
      /** @type {number[]} */
      include: [1],
      /** @type {number[]} */
      exclude: [],
    },
  },
  {
    generate({ answers }) {
      const textPieces = []

      if (!isEmpty(answers['40.a'])) {
        textPieces.push(`VEF1: ${answers['40.a']}`)
      }

      if (!isEmpty(answers['40.b'])) {
        textPieces.push(`CVF: ${answers['40.b']}`)
      }

      if (!isEmpty(answers['40.c'])) {
        textPieces.push(`VEF1/CVF: ${answers['40.c']}`)
      }

      if (!isEmpty(answers['40.d'])) {
        textPieces.push(`FEF 25-75%: ${answers['40.d']}%`)
      }

      if (answers['40.e'] === 'sim') {
        textPieces.push(`Tem prova ao broncodilatador positiva`)
      }

      if (!isEmpty(answers['40.f'])) {
        textPieces.push(`Laudo: ${answers['40.f']}`)
      }

      const sections = []

      if (textPieces.length) {
        sections.push(bulletSection('Espirometria:', textPieces))
      }

      return sections
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [1],
    },
  },
]
